import React, { useMemo, useState } from 'react';
import { HiCheckCircle, HiLightningBolt, HiChatAlt2 } from 'react-icons/hi';
import './WorkWithMe.css';

export default function WorkWithMe() {
  const [status, setStatus] = useState('idle');
  const [form, setForm] = useState({
    name: '',
    email: '',
    service: 'Project Management',
  });

  const canSubmit = useMemo(() => {
    return (
      form.name.trim().length > 1 &&
      /\S+@\S+\.\S+/.test(form.email) &&
      form.service.trim().length > 0
    );
  }, [form.email, form.name, form.service]);

  function onChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!canSubmit) {
      setStatus('error');
      return;
    }

    const subject = encodeURIComponent('Consultation Request - Website Inquiry');
    const body = encodeURIComponent(
      `Hi Emmanuel,\n\nI came across your website and I'm interested in discussing a potential collaboration.\n\n` +
        `My Details:\n` +
        `Name: ${form.name}\n` +
        `Email: ${form.email}\n` +
        `Service I'm interested in: ${form.service}\n\n` +
        `I'd appreciate the opportunity to schedule a consultation to discuss my project needs in more detail.\n\n` +
        `Looking forward to connecting with you.\n\n` +
        `Best regards,\n${form.name}`
    );

    window.location.href = `mailto:me@emmanuelobengconsulting.com?subject=${subject}&body=${body}`;

    setStatus('success');
    setTimeout(() => setStatus('idle'), 5000);
  }

  return (
    <section className="section workWithMe anchor" id="work-with-me">
      <div className="container workWithMe__inner">
        <div className="workWithMe__content">
          <div className="workWithMe__badge">Initial consultation</div>
          <h2 className="workWithMe__title">Work with me</h2>
          <p className="workWithMe__subtitle">
            Tell me what you’re working on and I’ll reply with clear next steps. No long forms.
          </p>

          <ul className="workWithMe__bullets" aria-label="What you get">
            <li>
              <HiCheckCircle className="workWithMe__bulletIcon" />
              <span>Clarity on scope, risks, and priorities</span>
            </li>
            <li>
              <HiLightningBolt className="workWithMe__bulletIcon" />
              <span>A practical plan for delivery or stabilization</span>
            </li>
            <li>
              <HiChatAlt2 className="workWithMe__bulletIcon" />
              <span>Direct, clear communication</span>
            </li>
          </ul>

          <div className="workWithMe__miniCta">
            Prefer to call?{' '}
            <a className="workWithMe__miniLink" href="tel:+233548239576">
              054 823 9576
            </a>
          </div>
        </div>

        <form className="workWithMe__form" onSubmit={onSubmit} aria-label="Lead generation form">
          <h3 className="workWithMe__formTitle">Quick inquiry</h3>
          <p className="workWithMe__formHint">Three fields only, quick and simple.</p>

          <label className="workWithMe__field">
            <span className="workWithMe__fieldLabel">Full name</span>
            <input
              name="name"
              value={form.name}
              onChange={onChange}
              placeholder="Your name"
              autoComplete="name"
              required
            />
          </label>

          <label className="workWithMe__field">
            <span className="workWithMe__fieldLabel">Email</span>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              placeholder="you@company.com"
              autoComplete="email"
              required
            />
          </label>

          <label className="workWithMe__field">
            <span className="workWithMe__fieldLabel">What do you need help with?</span>
            <select name="service" value={form.service} onChange={onChange} required>
              <option>Project Management</option>
              <option>IT Support & Infrastructure</option>
              <option>Both</option>
              <option>Not sure yet</option>
            </select>
          </label>

          <button
            className="workWithMe__submit"
            type="submit"
            disabled={!canSubmit || status === 'sending'}
          >
            {status === 'sending' ? 'Sending...' : 'Book a Consultation'}
          </button>

          {status === 'success' && (
            <div className="workWithMe__status workWithMe__status--success" role="status">
              ✅ Opening your email client to send the request...
            </div>
          )}

          {status === 'error' && (
            <div className="workWithMe__status workWithMe__status--error" role="alert">
              ❌ Please fill out all fields correctly.
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
